import React from 'react';
import { useTranslation } from 'react-i18next';

import LoginForm from '@/components/organisms/LoginForm';
import './Login.scss';

const Login: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="login-page">
      <div className="login-page__content">
        <LoginForm />
      </div>
    </div>
  );
};

export default Login; 